import { PropsWithChildren } from 'react';

import { Page } from '@/ui-kit/templates/Page';

export const ConfigurationPage = ({ children }: PropsWithChildren) => {
  return <Page>{children}</Page>;
};
